var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8.29 6.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#ffffff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "image") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ALL_-_ICONS",
    "data-name": "ALL - ICONS"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2.07,1.38a.35.35,0,0,1,.35.35.35.35,0,0,1-.35.34.34.34,0,0,1-.34-.34.35.35,0,0,1,.34-.35m0-.34a.69.69,0,1,0,.69.69A.69.69,0,0,0,2.07,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.6.35a.34.34,0,0,1,.34.34V5.87a.34.34,0,0,1-.34.34H.69a.35.35,0,0,1-.35-.34V.69A.35.35,0,0,1,.69.35H7.6M7.6,0H.69A.69.69,0,0,0,0,.69V5.87a.69.69,0,0,0,.69.69H7.6a.69.69,0,0,0,.69-.69V.69A.69.69,0,0,0,7.6,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2.07 3.45 0.34 5.18 0.34 5.67 2.07 3.94 4.34 6.21 4.83 6.21 2.07 3.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.94 4.49 5.52 2.07 3.11 4.49 3.11 4.98 5.52 2.56 7.94 4.98 7.94 4.49"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.eceb23b9329878ac11659559fc49733c.svg";
export { ForwardRef as ReactComponent };